$(function (){
    let $buyBtn = $('.js-buy'),
    $dropDown = $('.js-size-dropdown'),
    $productsList = $('.js-product-list');

    function toggleSize() {
        $(this).find('.js-size-dropdown').toggleClass('_opened');
        $(this).find('.js-size-list').toggleClass('_hidden');
        $(this).find('.js-dropdown-arrow').toggleClass('_opened');
        $(this).find('.js-buy').toggleClass('_hidden');
    }

    function closeSize() {
        if($dropDown.hasClass('_opened')) {
            $dropDown.removeClass('_opened');
            $('.js-size-list').addClass('_hidden');
            $('.js-dropdown-arrow').removeClass('_opened');
            $buyBtn.removeClass('_hidden');
        }
    }

    $productsList.slick({
        prevArrow: $(this).find('.js-left-arrow-product'),
        nextArrow: $(this).find('.js-right-arrow-product'),
        initialSlide: $productsList.data('defval'),
        dots: true
    });

    $('.js-comment-list').slick({
        prevArrow: $(this).find('.js-left-arrow-comment'),
        nextArrow: $(this).find('.js-right-arrow-comment'),
        dots: true
    });

    $dropDown.click(function (e) {
        e.stopPropagation();
        let $parent = $(this).parents('.js-product');
        toggleSize.call($parent);
    });

    $(window).click(function() {
        closeSize();
    });

    $('.js-size').click(function () {
        let $parent = $(this).parents('.js-product');
        $parent.find('.js-size-text').html($(this).html());
        $parent.data({'offer-id': $(this).data('offer-id')});
        $parent.data({'article': $(this).data('article')});
    });

    function selectedSize() {
        //console.log(this);
        return $(this).data('offer-id') > 0;
    }

    async function createOrder() {
        let result;
        try {
            result = await $.ajax({
                url: '/api/myCart/',
                type: 'POST',
                data: {
                    article: $(this).data('article'),
                    count: 1,
                    id: $(this).data('offer-id'),
                    token: $('shop').data('token'),
                    action: 'create'
                }

            });
            return JSON.parse(result);
        } catch (e) {

            console.log(e);
        }
        return  false;
    }

    $buyBtn.click( async function (e) {
        e.stopPropagation();
        let $parent = $(this).parents('.js-product');
        if(selectedSize.call($parent)) {
            let response = await createOrder.call($parent);
            if(response && response.status === 'ok') {
                location.href = '/personal/cart/';
            }
            //article: 2087-1
            // count: 1
            // id: 1812
            // token: 29a6df867a255c3836ff419d0902d181
            // action: create
            console.log($parent.data('id'));
            console.log($parent.data('offer-id'));
        } else {
            $parent.find('.js-size-dropdown').click();
        }
    })
});



//////////////////
// WEBPACK FOOTER
// ./src/js/milodrama.js
// module id = 3
// module chunks = 0 1 2